// Generated by `bazel run i18n`. Do not edit by hand.
import part0 from "./en/src--pages.json";
import part1 from "./en/src--tabs.json";
import part2 from "./en/src.json";

export default Object.assign(
  {},
  part0,
  part1,
  part2,
);
